import { getPendingClientLandingPath } from 'src/pages/companies/create-client-wizard/pendingClientSubscription';
import {
  CLIENT_BACKUPS,
  CLIENT_BACKUP_PORTAL,
  CLIENT_CASES,
  CLIENT_DASHBOARD,
  CLIENT_EDR_RESELLER_DASHBOARD,
  CLIENT_EDR_SOC,
  CLIENT_EDR_SUB_ORG_DASHBOARD,
  CLIENT_EXPLORER,
  CLIENT_HISTORY,
  CLIENT_LISTS,
  CLIENT_ORDERS,
  CLIENT_PRICES,
  CLIENT_SUBSCRIPTIONS,
  CLIENT_REPORTING,
  CLIENT_SUPPORT,
  CLIENT_USERS,
  CLIETN_COMPANIES,
} from 'src/constants/constants';

type LandingRoute = {
  permission: string;
  path: string;
};

export const PERMISSION_LANDING_FALLBACK = '/401';

// Keep this priority aligned with DashboardSidebar order (visible items only).
export const permissionLandingPriority: LandingRoute[] = [
  { permission: CLIENT_DASHBOARD, path: '/cases/dashboard' },
  { permission: CLIENT_EDR_SOC, path: '/mindtime/security/soc' },
  { permission: CLIETN_COMPANIES, path: '/clients' },
  { permission: CLIENT_BACKUPS, path: '/mindtime/my-backups' },
  { permission: CLIENT_BACKUP_PORTAL, path: '/mindtime/backup-portal' },
  { permission: CLIENT_EDR_RESELLER_DASHBOARD, path: '/mindtime/security/edr/reseller-dashboard' },
  { permission: CLIENT_EDR_SUB_ORG_DASHBOARD, path: '/mindtime/security/edr/sub-org-dashboard' },
  { permission: CLIENT_SUPPORT, path: '/mindtime/support' },
  { permission: CLIENT_EXPLORER, path: '/mindtime/support' },
  { permission: CLIENT_CASES, path: '/cases/all' },
  { permission: CLIENT_HISTORY, path: '/mindtime/history' },
  { permission: CLIENT_REPORTING, path: '/reporting' },
  { permission: CLIENT_SUBSCRIPTIONS, path: '/subscriptions' },
  { permission: CLIENT_ORDERS, path: '/orders' },
  { permission: CLIENT_PRICES, path: '/mindtime/prices' },
  { permission: CLIENT_USERS, path: '/users' },
  { permission: CLIENT_LISTS, path: '/mindtime/lists' },
];

export const getPermissionLandingPath = (
  permissions: string[] = []
): string | null => {
  const firstAllowedRoute = permissionLandingPriority.find(({ permission }) =>
    permissions.includes(permission)
  );

  return firstAllowedRoute?.path ?? null;
};

export const getPermissionLandingPathOrFallback = (
  permissions: string[] = [],
  fallback = PERMISSION_LANDING_FALLBACK
): string => getPermissionLandingPath(permissions) ?? fallback;

export const ONBOARDING_CREATE_PATH = '/organizations/create';

/** Flip to `true` to restore forced org onboarding wizard for `isOnBoarded === false`. */
export const ONBOARDING_FEATURE_ENABLED = false;

type AuthenticatedLandingUser = {
  id?: string;
  keycloak_id?: string;
  userKeyCloakId?: string;
  user_id?: string;
  email?: string;
  permissions?: string[];
  organization?: { isOnBoarded?: boolean };
};

/** Post-login / post-auth route: onboarding wizard or permission-based dashboard. */
export const getAuthenticatedLandingPath = (
  user: AuthenticatedLandingUser | null | undefined
): string => {
  if (ONBOARDING_FEATURE_ENABLED && user?.organization?.isOnBoarded === false) {
    return ONBOARDING_CREATE_PATH;
  }

  return (
    getPendingClientLandingPath() ??
    getPermissionLandingPathOrFallback(user?.permissions ?? [])
  );
};
